<template>
  <div v-if="isAdminLayout">
    <!--SPINNER-->
    <div  v-if="loading" class="Vlt-grid Vlt-margin--A-bottom2">
      <div class="Vlt-col Vlt-center">
        <vlt-spinner></vlt-spinner>
      </div>
    </div>

    <div v-if="domainUsersData && domainUsersData.length > 0 ">
      <!--SEARCH-->
      <h4>
        <span>
          <vlt-icon class="Vlt-black Vlt-margin--bottom1" icon="search"/>
        </span>&nbsp;
        {{$t('message.dashboard.searchNumber.search_number_or_name')}}
      </h4>
      <div class="Vlt-grid Vlt-margin--A-bottom2">
        <!--SEARCH-->
        <div class="Vlt-col Vlt-col--2of4">
          <div class="Vlt-composite">
            <div class="Vlt-composite__prepend Vlt-composite__prepend--icon">
              <div class="Vlt-composite__icon">
                <vlt-icon class="Vlt-grey Vlt-margin--bottom1" icon="search" small/>
              </div>
            </div>
            <div class="Vlt-input">
              <input
                type="search"
                id="search-input-icon-button"
                autocomplete="off"
                :placeholder="$t('message.dashboard.searchNumber.search_number_or_name')"
                v-model="filter"/>
            </div>
          </div>
        </div>
      </div>

      <!--  DATA TABLE-->
      <div class="Vlt-grid flexContainer">
        <div class="Vlt-col colUsersTable">
          <vlt-button
            @click="onClickAdd"
            app
            big
            icon="plus"
            label="Add User"
          />
          <vlt-table-hover-row-btns
            v-if="!loading"
            :columns="columns"
            :rows="filtered"
            :pagination="filtered.length > pageSize"
            :pageSize="pageSize"
          >
            <template slot="item" slot-scope="slotProps">
                <td >{{ slotProps.item.phone }}</td>
                <td >{{ slotProps.item['caller_name'] }}</td>
                <td >{{ mapRole(slotProps.item.role) }}</td>
                <td class="Vlt-btn-group Vlt-btn-group--icon Vlt-btn-group--icon Vlt-btn-group--small Vlt-btn-group--hover">
                  <button class="Vlt-btn Vlt-btn--icon" @click="onClickEdit(slotProps.item.phone)">
                    <vlt-icon icon="edit"></vlt-icon>
                  </button>
                  <button class="Vlt-btn Vlt-btn--icon" @click="onClickDelete(slotProps.item.phone)">
                    <vlt-icon icon="bin"></vlt-icon>
                  </button>
                </td>
            </template>
          </vlt-table-hover-row-btns>
        </div>
      </div>

    </div>
    <!--    NO RESULTS-->
    <div v- v-else-if="(!domainUsersData || domainUsersData.length === 0) && !loading ">
      <div class="Vlt-empty">
        <div class="Vlt-empty__content">
          {{$t('message.dashboard.no_records')}}
        </div>
      </div>
    </div>
    <!--MODALS-->
    <!--EDIT-->
    <edit-user-modal
      v-if="showEditUserModal"
      :visible="showEditUserModal"
      @onClose="showEditUserModal = false"
      :origUser="selectedUser"
      edit
      :onSaveUser="onSaveUser"
    />
    <!--ADD-->
    <edit-user-modal
      v-if="showAddUserModal"
      :visible="showAddUserModal"
      @onClose="showAddUserModal = false"
      :edit ="false"
      :onSaveUser="onSaveUser"
    />
    <!--DELETE-->
    <delete-user-modal
      v-if="showDeleteUserModal"
      :visible="showDeleteUserModal"
      @onClose="showDeleteUserModal = false"
      @updateUserList="updateUserList"
      :selectedUser="selectedUser"
      :onDeleteUser="onDeleteUser"
    />
  </div>
</template>

<script>
  import { cloneDeep } from 'lodash';
  import { mapActions, mapGetters, mapMutations  } from 'vuex';
  import EventBus from 'Utils/event-bus';
  import {
      VltIcon,
      VltButton,
      VltSpinner,
      VltTable,
      VltCallout,
      VltField,
      VltInput,
      VltTooltip,
      VltCheckbox,
  } from '@vonagevolta/vue';

  import {
      FETCH_DOMAIN_USERS,
      SAVE_DOMAIN_USER,
      DELETE_DOMAIN_USER,
  } from 'Store/action-types';
  import {
      SET_SEARCH_NUMBER_ERR,
  } from 'Store/mutation-types';
  import VltTableHoverRowBtns from 'Components/common/VltTableHoverRowBtns';

  import EditUserModal from 'Components/common/modals/EditUserModal.vue';
  import DeleteUserModal from 'Components/common/modals/DeleteUserModal.vue';

  export default {
    name: "ManageUsers",
    components: {
        VltIcon,
        VltButton,
        VltSpinner,
        VltTable,
        VltCallout,
        VltField,
        VltInput,
        VltTooltip,
        VltCheckbox,
        VltTableHoverRowBtns,
        EditUserModal,
        DeleteUserModal,
    },
    directives: {
      focus: {
        inserted: function (el) {
          el.focus()
        }
      }
    },
    data() {
      return {
        processing: false,
        term: '',
        termError: null,
        filter: '',
        filteredDomainUsers: [],
        fuseOptions: {
          shouldSort: true,
          minMatchCharLength: 2,
          threshold: 0.2,
          location: 0,
          distance: 1000,
          maxPatternLength: 32,
          keys: [
            {
              name: 'phone',
              weight: 0.5,
            },
            {
              name: 'caller_name',
              weight: 0.5,
            },
          ],
        },
        debounce: null,
        columns: [
          { title: 'Number', property: 'phone', sortable: true },
          { title: 'Name', property: 'caller_name', sortable: true },
          { title: 'Role', property: 'role', sortable: false },
        ],
        pageSize: 10,
        noFoundNumber: null,
        editCell: '',
        initEditValue: '',
        editing: false,
        newNumber: '',
        isConnecting: false,
        showEditUserModal: false,
        showDeleteUserModal: false,
        showAddUserModal: false,
        selectedUser: null,
        readableRoles:  {
            SUPERVISOR: 'Administrator',
            TALENT: 'User',
        },
      };
    },
    props: {},

    computed: {
      ...mapGetters({
          isAdmin: 'isAdmin',
          domainUsersData: 'getDomainUsers',
          loading: 'getLoading',
          isAdminLayout: 'getIsAdminLayout',
      }),
      filtered() {
        return this.filteredDomainUsers && this.filteredDomainUsers.length > 0
            ? this.filteredDomainUsers
            : !this.filteredDomainUsers.length && this.term ? [] : this.domainUsersData;
      },
    },
    watch: {
        loading(current) {
        },
        term(current) {
            this.validateNumber(current);
        },
        searchNumberErr: {
            immediate: true,
            handler(newProp) {
                this.numberFromNoSearchRes = this.term + '';
            },
        },
        domainUsersData: {
            immediate: true,
            handler(newProp) {
                // console.log('=========== domainUsers: ', newProp);
            },
        },
        async filter(term) {
          if (!term || !term.trim()) {
            this.filteredDomainUsers = this.domainUsersData;
          } else {
            this.debounceSearch(term);
          }
        },
        isAdminLayout(current) {
          if(!current) {
            this.$router.push('/dashboard/manage');
          }
        },
    },
    methods: {
      mapRole(role) {
        return this.readableRoles[role] || 'N/A'
      },
        debounceSearch(term) {
            clearTimeout(this.debounce);
            this.debounce = setTimeout( async () => {
                this.term = term;
                // console.log('Term: ', this.term);
                this.filteredDomainUsers = await this.$search(term, this.domainUsersData, this.fuseOptions);
                // console.log('this.filteredNumbers: ',this.filteredNumbers)
            }, 600)
        },
        ...mapMutations({
            setSearchErr: `${SET_SEARCH_NUMBER_ERR}`,
        }),
        ...mapActions({
            fetchDomainUsers: `${FETCH_DOMAIN_USERS}`,
            saveUser: `${SAVE_DOMAIN_USER}`,
            deleteUser: `${DELETE_DOMAIN_USER}`,
        }),
        init() {
            this.fetchDomainUsers();
        },
        async doSearch() {
            this.processing = true;
            const term = this.term;
            if (!term || !term.trim()) {
                this.termError = this.$i18n.t('message.dashboard.empty_value');
                this.processing = false;
                return;
            }
            const isValidNumber = this.isValidNumber(term);
            if (this.validatedNumber && isValidNumber) {
                this.termError = ''
            }
            await this.search({ feedNumber: term, autoJoin: this.autoJoin });
            this.processing = false;
        },

        isValidNumber(term) {
            const exp = /(?:\(?\+\d{2}\)?\s*)?\d+(?:[ -.]*\d+)*[) ]*$/g;
            const trimmedNumber = term.trim();
            const isValid = exp.test(trimmedNumber);

            if (isValid) {
                if (!trimmedNumber.startsWith('+') && !trimmedNumber.startsWith('(')) {
                    this.validatedNumber = `+1${trimmedNumber}`;
                } else {
                    this.validatedNumber = trimmedNumber;
                }
                return true;
            }
            return false;
        },
        validateNumber(number) {
            if (this.isValidNumber(number)) {
                this.termError = '';
            } else {
                this.termError = this.$i18n.t('message.login.error3');
            }
        },
        onChangeField() {
            // clean up errors
            this.termError = null;
        },
        onSave(e) {
            this.editCell = '';
            this.editing = true;
            const newDescValue = e.target.value.trim();
            const id = e.target.id;
            const numId  = id.substring(id.lastIndexOf('-') + 1);
            this.saveDescription({value: newDescValue, numId});
            this.editing = false;
        },
        onDismissErr() {
            this.noFoundNumber = null;
            this.setSearchErr('');
        },
        onClickEdit(number) {
            this.selectedUser = cloneDeep(this.getUserById(number));
            this.showEditUserModal = true;
        },
        onClickAdd() {
            this.showAddUserModal = true;
        },
        onClickDelete(number) {
            this.selectedUser = cloneDeep(this.getUserById(number));
            this.showDeleteUserModal = true;
        },
        getUserById(number) {
          const user = this.domainUsersData.find((el)=> el.phone === number)
          console.log('user:  ', user);
          return user;
        },
        updateUserList({ id, action }) {
            // let deleted = false;
            // if (action === 'delete') {
            //     deleted = this.deleteUserFromList(id);
            // }
            // return deleted;
        },
        async onSaveUser(edit, user) {
          await this.saveUser({edit, user})
        },
        async onDeleteUser(user) {
          await this.deleteUser({user})
        },

    },
    created() {
      if (!this.isAdmin || !this.isAdminLayout) {
          this.$router.push('/dashboard/manage');
      }
      this.init();
    },
    mounted() {
      EventBus.$on('reloadUsers', this.fetchDomainUsers);
    },
    beforeDestroy() {
      EventBus.$off('reloadUsers');
    },
  }
</script>

<style scoped lang="scss">
  .Vlt-btn-group--hover {
    margin-top: 10px;
  }
</style>
